import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdvertService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.baseUrl}/advert`,{params:searchParams});
    }

    get(deviceId){
      return this.http.get(`${environment.baseUrl}/advert/`+deviceId);
    }

    edit(deviceId,formData){
      return this.http.put(`${environment.baseUrl}/advert/`+deviceId,formData);
    }

    create(formData){
      return this.http.post(`${environment.baseUrl}/advert`,formData);
    }

    delete(deviceId){
      return this.http.delete(`${environment.baseUrl}/advert/`+deviceId);
    }

}
